import { render, staticRenderFns } from "./ModalAgregarComentario.vue?vue&type=template&id=1d6ec454&scoped=true&"
import script from "./ModalAgregarComentario.vue?vue&type=script&lang=js&"
export * from "./ModalAgregarComentario.vue?vue&type=script&lang=js&"
import style0 from "./ModalAgregarComentario.vue?vue&type=style&index=0&id=1d6ec454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6ec454",
  null
  
)

export default component.exports